import { useContext } from 'react';
import { Card, CardActions, CardContent, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Pencil, TrashSimple } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';
import { Contract } from '../../types/ContractType';
import { useTheme } from '../../providers/theme';
import { TextComponent } from '../TextComponent';
import { UserDataContext } from '../../providers/userData';
import { ContractNameContext } from '../../providers/contractName';

type CardProps = {
  contractData: Contract;
  number: string;
  ownerId: string;
  onEdit: (contract: Contract) => void;
  onDelete: (contractId: string) => void;
}

export function BasicCard({ contractData, number, ownerId, onEdit, onDelete }: CardProps) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { userData } = useContext(UserDataContext);
  const { setContractNumber } = useContext(ContractNameContext);
  const { t } = useTranslation();

  const handleNavigate = () => {
    navigate(`/contracts/${contractData.id}/projects`);
    setContractNumber(contractData.number);
  };

  return (
    <>
      <Card sx={{ width: '16.9rem', background: '#FAFAFA', margin: 1, boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px;' }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column' }}>
          <TextComponent
            children={number}
            fontSize='18px'
            fontWeight='bold'
            color='#000'
          />
          <TextComponent
            children={ownerId}
            fontSize='13px'
            color='#000'
          />
        </CardContent>

        <CardActions sx={{ backgroundColor: '#FEFEFE', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button
            id={number}
            type='button'
            onClick={handleNavigate}
            color={theme.colors.main}
            sxhover={theme.colors.hoverMain}
            sxwidth='140px'
          >
            {t('projects-page-view')}
          </Button>

          {userData.admin && (
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <Tooltip title={t('group-table-action-edit')}>
                <Pencil onClick={() => onEdit(contractData)} size={27} color={theme.colors.main} weight='fill' cursor='pointer' />
              </Tooltip>
              <Tooltip title={t('group-table-action-delete')}>
                <TrashSimple onClick={() => onDelete(contractData.id)} size={27} color={theme.colors.red} weight='fill' cursor='pointer' />
              </Tooltip>
            </div>
          )}
        </CardActions>
      </Card>
    </>
  );
}
